// import { initializeApp } from "firebase/app";
// import { getFirestore } from "firebase/firestore";
// import {
//   getAuth,
//   GoogleAuthProvider,
//   FacebookAuthProvider,
//   signInWithPopup,
// } from "firebase/auth";
// import { getStorage } from "firebase/storage";
// import { getDatabase } from "firebase/database";

// const firebaseConfig = {
//   apiKey: "AIzaSyC5BWuzb2TyhVL-wen7Cly9bbg83GfPIf4",
//   authDomain: "phototime-c34bc.firebaseapp.com",
//   projectId: "phototime-c34bc",
//   storageBucket: "phototime-c34bc.firebasestorage.app",
//   messagingSenderId: "611644918102",
//   appId: "1:611644918102:web:3241dc67a6cc838e17aef7",
//   measurementId: "G-WK9SEC1D79",
// };

// const app = initializeApp(firebaseConfig);
// const db = getDatabase(app);
// const auth = getAuth(app);
// const provider = new GoogleAuthProvider();
// const storage = getStorage(app);
// const facebookProvider = new FacebookAuthProvider();
// export { db, auth, provider, storage, facebookProvider };

import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  FacebookAuthProvider,
} from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyDLvBpxzAutr-kCJSg-9gWC34CeLaSYS3k",
  authDomain: "revenue-manager-f2ae4.firebaseapp.com",
  projectId: "revenue-manager-f2ae4",
  storageBucket: "revenue-manager-f2ae4.firebasestorage.app",
  messagingSenderId: "85020028177",
  appId: "1:85020028177:web:ba7ca7b3f7ef997a09b0b0",
  measurementId: "G-7MHZ9KP7X9"
};

const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const storage = getStorage(app);
const facebookProvider = new FacebookAuthProvider();
export { db, auth, provider, storage, facebookProvider };
